import { loadEnv } from '../../shims/load-env';

export const HEPAI_API_KEY_ENV_VARIABLE_NAME = 'HEPAI_API_KEY';
export const HEPAI_BASE_URL_ENV_VARIABLE_NAME = 'HEPAI_BASE_URL';
export const HEPAI_DEFAULT_MODEL_ENV_VARIABLE_NAME = 'HEPAI_DEFAULT_MODEL';

export const DEFAULT_HEPAI_BASE_URL = 'https://ai-chat.hep.com.cn/llm';
export const DEFAULT_HEPAI_MODEL = 'personal_deepseek_v4';

export function getDefaultHepAIKey(): string | undefined {
  return loadEnv()[HEPAI_API_KEY_ENV_VARIABLE_NAME];
}

export function getDefaultHepAIBaseURL(): string {
  return loadEnv()[HEPAI_BASE_URL_ENV_VARIABLE_NAME] ?? DEFAULT_HEPAI_BASE_URL;
}

export function getDefaultHepAIModel(): string {
  return (
    loadEnv()[HEPAI_DEFAULT_MODEL_ENV_VARIABLE_NAME] ?? DEFAULT_HEPAI_MODEL
  );
}
